'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _signupOrLoginButton = require('./signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CTAButton(p) {
    var buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
    var linkURL = '/home/myAccount#integrations';

    return _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, p, {
        buttonText: p.buttonText,
        homeUrl: linkURL,
        redirectUrl: linkURL,
        googleOpenIdUrl: p.googleOpenIdLocationUrl,
        buttonClass: buttonClass,
        isIntegration: true,
        buttonTextColor: 'white',
        buttonColor: 'cerulean',
        buttonBorderColor: 'cerulean',
        buttonHoverColor: 'cerulean',
        buttonHoverTextColor: 'white' }));
}

module.exports = CTAButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/cta-button.jsx
 ** module id = 1531
 ** module chunks = 0
 **/